import { Box, Typography, Card, CardContent } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { partners } from "../assets";

function AwardsAndPrograms() {
    const { t } = useTranslation();

    const alexaLogo =
        partners.alexaChampion ||
        partners.alexaChampionHeader ||
        partners.alexaChampionHeader1;
    const gfsLogo = partners.googleForStartups;

    const awardCards = t("awards.cards", { returnObjects: true }) || [];

    return (
        <Box component="section" sx={{ bgcolor: "#FFFFFF" }}>
            <Box
                sx={{
                    width: { xs: "100%", lg: "1440px" },
                    mx: "auto",
                    py: { xs: 6, md: 8 },
                    px: { xs: 2, sm: 3, lg: 0 },
                }}
            >
                {/* topo: texto + card verde */}
                <Box
                    sx={{
                        width: { xs: "100%", lg: "1240px" },
                        mx: "auto",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", lg: "repeat(2, 595px)" },
                        columnGap: { lg: 6 },
                        rowGap: { xs: 3, lg: 0 },
                        alignItems: "start",
                        "& > *": { maxWidth: { xs: 358, sm: 720, lg: "unset" }, mx: { xs: "auto", lg: 0 } },
                    }}
                >
                    {/* coluna texto */}
                    <Box sx={{ maxWidth: { lg: "595px" } }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#0f1011",
                                letterSpacing: 0.6,
                                mb: 2,
                                fontWeight: 800,
                                fontSize: { xs: 14, md: 16, lg: 18 },
                                lineHeight: 1.6,
                                textAlign: { xs: "center", lg: "left" },
                            }}
                        >
                            <Trans components={{ bold: <Box key="bold" component="strong" sx={{ fontWeight: 800 }} /> }}>
                                {t("awards.trusted1")}
                            </Trans>
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#0f1011",
                                letterSpacing: 0.6,
                                fontSize: { xs: 14, md: 16, lg: 18 },
                                lineHeight: 1.6,
                                textAlign: { xs: "center", lg: "left" },
                            }}
                        >
                            <Trans components={{ bold: <Box key="bold" component="strong" sx={{ fontWeight: 800 }} /> }}>
                                {t("awards.trusted2")}
                                <br />
                            </Trans>
                        </Typography>
                    </Box>

                    {/* card verde logos */}
                    <Card
                        elevation={0}
                        sx={{
                            width: { lg: "595px" },
                            height: { lg: "252.92px" },
                            bgcolor: "#CEFF1A",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: { xs: 2.5, md: 4 },
                            boxShadow: "none",
                            transition: "box-shadow .25s ease, transform .25s ease",
                            "&:hover": { boxShadow: (theme) => theme.shadows[6] },
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: { xs: "center", lg: "space-evenly" },
                                gap: { xs: 2, sm: 3, md: 4 },
                                flexWrap: { xs: "wrap", sm: "nowrap" },
                            }}
                        >
                            {alexaLogo && (
                                <Box
                                    component="img"
                                    src={alexaLogo}
                                    alt="Alexa Champions logo"
                                    sx={{
                                        maxWidth: { xs: 150, sm: 180, lg: 200 },
                                        maxHeight: { xs: 120, lg: "204.92px" },
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                            )}
                            {gfsLogo && (
                                <Box
                                    component="img"
                                    src={gfsLogo}
                                    alt="Google for Startups logo"
                                    sx={{
                                        maxWidth: { xs: 150, sm: 180, lg: 200 },
                                        maxHeight: { xs: 120, lg: 200 },
                                        width: "100%",
                                        height: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                            )}
                        </Box>
                    </Card>
                </Box>

                {/* grid de prêmios */}
                <Box
                    sx={{
                        width: { xs: "100%", lg: "1248px" },
                        mx: "auto",
                        mt: { xs: 5, md: 6 },
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1fr", lg: "repeat(3, 382.67px)" },
                        justifyContent: { lg: "space-between" },
                        gap: { xs: 3, md: 4 },
                        px: { xs: 2, sm: 3, lg: 0 },
                    }}
                >
                    {[
                        { bg: "#0f1011", titleColor: "#CEFF1A", idx: 0 },
                        { bg: "#CEFF1A", titleColor: "#0f1011", idx: 1 },
                        { bg: "#0f1011", titleColor: "#CEFF1A", idx: 2 },
                    ].map(({ bg, titleColor, idx }) => (
                        <Card
                            key={idx}
                            elevation={0}
                            sx={{
                                bgcolor: bg,
                                color: bg === "#0f1011" ? "#FFF" : "#0f1011",
                                borderRadius: { xs: "24px", lg: 2 },
                                width: { lg: "382.67px" },
                                minHeight: { lg: "265px" },
                                boxShadow: "none",
                                transition: "box-shadow .25s ease, transform .25s ease",
                                "&:hover": { boxShadow: (theme) => theme.shadows[6] },
                                maxWidth: { xs: 358, sm: 358, lg: "unset" },
                                mx: { xs: "auto", lg: 0 },
                            }}
                        >
                            <CardContent
                                sx={{
                                    p: { xs: 2.5, md: 3.25 },
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 800,
                                        letterSpacing: 0.5,
                                        color: titleColor,
                                        textAlign: "center",
                                        textTransform: "uppercase",
                                        fontSize: { xs: 19.5, md: 22, lg: 26 },
                                        lineHeight: 1.25,
                                    }}
                                >
                                    <Trans components={{ bold: <Box key="bold" component="strong" sx={{ fontWeight: 800 }} /> }}>
                                        {awardCards[idx]?.title || ""}
                                    </Trans>
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        textAlign: "center",
                                        fontSize: { xs: 15.5, md: 16, lg: 18 },
                                        lineHeight: 1.6,
                                        opacity: bg === "#0f1011" ? 0.95 : 1,
                                    }}
                                >
                                    <Trans components={{ bold: <Box key="bold" component="strong" sx={{ fontWeight: 800 }} /> }}>
                                        {awardCards[idx]?.body || ""}
                                    </Trans>
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default AwardsAndPrograms;